import React, { CSSProperties } from 'react';
import { IconType } from 'react-icons';

interface IconWrapperProps {
    icon: IconType | (() => React.ReactElement);
    className?: string;
    size?: number;
    color?: string;
    style?: CSSProperties;
}

const IconWrapper: React.FC<IconWrapperProps> = ({ icon: Icon, className, size, color, style }) => {
    const [isPortrait, setIsPortrait] = React.useState(
        window.matchMedia("(orientation: portrait)").matches
    );

    React.useEffect(() => {
        const mediaQuery = window.matchMedia("(orientation: portrait)");
        const handleOrientationChange = (e: MediaQueryListEvent) => {
            setIsPortrait(e.matches);
        };

        mediaQuery.addEventListener("change", handleOrientationChange);
        return () => {
            mediaQuery.removeEventListener("change", handleOrientationChange);
        };
    }, []);

    const iconSize = isPortrait ? (size || 24) * 1.5 : size;

    return (
        <span className={className} style={{
            ...style,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            {React.isValidElement(Icon) ?
                Icon :
                typeof Icon === 'function' ?
                    Icon({
                        size: iconSize,
                        color,
                        className,
                        style: {
                            display: 'block',
                            transition: 'all 0.3s ease',
                        }
                    }) :
                    Icon
            }
        </span>
    );
};

export default IconWrapper;
